import classnames from 'classnames'
import { equals, isEmpty } from 'ramda'
import React, { Component } from 'react'
import { Redirect } from 'react-router-dom'

import BlockUpdatesRequiredModal from 'components/BlockUpdatesRequiredModal'
import { EDITOR_COMPONENTS } from 'constants/components'
import { BOT_FLOW_MODES } from 'modules/editor/reducer'
import { SupportedPlaybookTypes } from 'types/Playbook'
import { pause } from 'utils'

import './style.css'

const resolveTypeContext = (type) => EDITOR_COMPONENTS[type] || <div />

class EditorContext extends Component {
  state = {
    forceRemount: false,
    blockUpdatesModalOpen:
      !!this.props.outdatedBlocks && !isEmpty(this.props.outdatedBlocks),
  }

  componentDidUpdate(prevProps) {
    const isPreviewingChange =
      prevProps.isPreviewState !== this.props.isPreviewState
    const isTypeChange = prevProps.type !== this.props.type
    const isPreviewStateChange =
      this.props.isPreviewState &&
      !equals(prevProps.playbook, this.props.playbook)

    const isBotFlowModeChange = prevProps.botFlowMode !== this.props.botFlowMode
    if (
      isPreviewingChange ||
      isTypeChange ||
      isPreviewStateChange ||
      isBotFlowModeChange
    ) {
      this.setState(() => ({ forceRemount: true }), this.resetForceRemount)
    }

    const isBlockUpdatesChange =
      prevProps.outdatedBlocks !== this.props.outdatedBlocks
    if (isBlockUpdatesChange) {
      this.setState(() => ({
        blockUpdatesModalOpen:
          !!this.props.outdatedBlocks && !isEmpty(this.props.outdatedBlocks),
      }))
    }
  }

  resetForceRemount = async () => {
    await pause(0)
    this.setState(() => ({ forceRemount: false }))
  }

  toggleBlockUpdatesModal = () => {
    this.setState(() => ({
      blockUpdatesModalOpen: !this.state.blockUpdatesModalOpen,
    }))
  }

  render() {
    const { forceRemount, blockUpdatesModalOpen } = this.state
    const {
      isPreviewState,
      type,
      onChange,
      onCreateExperiment,
      onTransientChange,
      playbook,
      versionTimestamps,
      canSwitchEditors,
      title,
      isAIEnabled,
      outdatedBlocks,
      botFlowMode,
    } = this.props

    const notSupported = equals(type, SupportedPlaybookTypes.NOT_SUPPORTED)
    const EditorComponent = resolveTypeContext(type)

    if (forceRemount) return null
    if (notSupported) return <Redirect to="/not-found" />

    return (
      <div
        className={classnames('playbook-editor-context', {
          'preview-state': isPreviewState,
          'content-review-mode': botFlowMode === BOT_FLOW_MODES.CONTENT_VIEW,
        })}
        key={`editor-context-${type}`}
      >
        {blockUpdatesModalOpen && (
          <BlockUpdatesRequiredModal
            isOpen={true}
            onClose={this.toggleBlockUpdatesModal}
            outdatedBlocks={outdatedBlocks}
          />
        )}

        <EditorComponent
          onTransientChange={onTransientChange}
          title={title}
          onChange={onChange}
          onCreateExperiment={onCreateExperiment}
          playbook={playbook}
          versionTimestamps={versionTimestamps}
          canSwitchEditors={canSwitchEditors}
          isAIEnabled={isAIEnabled}
        />
      </div>
    )
  }
}

export default EditorContext
